import * as React from 'react';

import { mobilePaytableConfigurationContext, frameworkMobilePaytable } from './mobilePaytableconfiguration';

const withMobilePaytableConfiguration = <P extends object>(
    WrappedComponent: React.ComponentType<P>): React.FC<P> => {
    const HOC = (props: any): React.ReactElement => (
        <mobilePaytableConfigurationContext.Consumer>
            {(): React.ReactElement => {
                return (
                    <WrappedComponent {...props}{...frameworkMobilePaytable} />
                );
            }}
        </mobilePaytableConfigurationContext.Consumer>
    );

    HOC.displayName = `withAuthentication(${WrappedComponent.displayName || WrappedComponent.name})`;
    HOC.WrappedComponent = WrappedComponent;
    return HOC;
};

export default withMobilePaytableConfiguration;